var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "user_main_settings" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "row pt-5" }, [
        _c("div", { staticClass: "col-lg-4 col-md-4 col-xs-12 col-xl-4" }, [
          !_vm.is_user_redirect
            ? _c("div", { staticClass: "user_add cursor-pointer" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "add user d-inline-flex flex-row flex-nowrap text-truncate align-items-center gap-3",
                    on: { click: _vm.add_user },
                  },
                  [
                    _c("i", {
                      staticClass: "fa add_user fa-plus-square",
                      staticStyle: { "font-size": "22px" },
                      attrs: { title: "", "data-type": "delegate_users" },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass:
                          "ml-1 fw-bold fs-lg text-wrap text-truncate",
                      },
                      [_vm._v("Оберіть користувача для переадресації")]
                    ),
                  ]
                ),
              ])
            : _c(
                "div",
                { staticClass: "user_to_fire" },
                [
                  _vm.obj_to_null(this.user_redirect)
                    ? _c("user_block", {
                        key: _vm.user_redirect.id,
                        attrs: {
                          can_del: true,
                          del_triger: _vm.remove_fire_from_doc,
                          user: _vm.user_redirect,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-6 col-md-6 col-xs-12 col-xl-6" }, [
          _c("div", { staticClass: "form-group mt-2 mt-md-0" }, [
            _c(
              "label",
              { staticClass: "fw-bold fs-lg text-wrap text-truncate" },
              [
                _vm._v(
                  "\n\t\t\t\t\t\tШаблон службової для переадресації\n\t\t\t\t\t"
                ),
              ]
            ),
            _vm._v(" "),
            _vm.questions_list.length > 0
              ? _c(
                  "div",
                  {
                    staticClass:
                      "d-flex flex-row flex-nowrap align-items-center",
                  },
                  [
                    _c(
                      "v-select",
                      {
                        staticClass: "imc_reasons w-100",
                        attrs: {
                          label: "title",
                          options: _vm.questions_list,
                          filterable: true,
                          placeholder: "Оберіть питання для додавання в список",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "option",
                              fn: function (option) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex p-1 mr-2" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "icon-stack fs-xxl" },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "base base-7 icon-stack-3x opacity-100 color-primary-500",
                                          }),
                                          _vm._v(" "),
                                          _c("i", {
                                            staticClass:
                                              "base base-7 icon-stack-2x opacity-100 color-primary-300",
                                          }),
                                          _vm._v(" "),
                                          _c("i", {
                                            staticClass:
                                              "fal fa-bookmark icon-stack-1x opacity-100 color-white",
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "org_title ml-2" },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(option.title) +
                                              "\n\t\t\t\t\t\t\t\t\t"
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1833006008
                        ),
                        model: {
                          value: _vm.question_selected,
                          callback: function ($$v) {
                            _vm.question_selected = $$v
                          },
                          expression: "question_selected",
                        },
                      },
                      [
                        _c("template", { slot: "no-options" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\tОберіть питання для додавання в список\n\t\t\t\t\t\t\t"
                          ),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "ml-2 btn btn-success",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.addTemplateQuestions.apply(
                              null,
                              arguments
                            )
                          },
                        },
                      },
                      [_vm._v("Додати")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm._l(_vm.questions_redirect_list, function (item) {
        return _c("div", { staticClass: "row pt-2" }, [
          _c(
            "div",
            { staticClass: "col-lg-10 col-md-10 col-xs-12 col-xl-10" },
            [
              _c("div", { staticClass: "user_to_fire" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "user_profile bg-gradient-primary bd-callout bd-callout-info position-relative p-3",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "rem_user_ins position-absolute btn btn-icon btn-sm btn-danger shadow waves-effect waves-themed cursor-pointer",
                        staticStyle: { top: "2px", right: "2px" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.deleteQuestionRedirect(item?.id)
                          },
                        },
                      },
                      [_c("i", { staticClass: "fal fa-times" })]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "fs-xl text-wrap" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(item.title) +
                          "\n\t\t\t\t\t\t"
                      ),
                    ]),
                  ]
                ),
              ]),
            ]
          ),
        ])
      }),
      _vm._v(" "),
      _c("div", { staticClass: "mt-3 text-right" }, [
        _c(
          "button",
          {
            staticClass:
              "btn btn-lg btn-outline-primary waves-effect waves-themed",
            attrs: { type: "button" },
            on: { click: _vm.save_settings },
          },
          [
            _c("span", { staticClass: "fal fa-check mr-1" }),
            _vm._v("\n\t\t\t\tЗберегти\n\t\t\t"),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex flex-start w-100" }, [
      _c("div", { staticClass: "mr-2 hidden-md-down" }, [
        _c("span", { staticClass: "icon-stack icon-stack-lg" }, [
          _c("i", {
            staticClass:
              "base base-6 icon-stack-3x opacity-100 color-primary-500",
          }),
          _vm._v(" "),
          _c("i", {
            staticClass:
              "fa fa-long-arrow-right icon-stack-1x opacity-100 color-white",
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-fill" }, [
        _c("div", { staticClass: "flex-fill" }, [
          _c("span", { staticClass: "h5" }, [
            _vm._v("Налаштування параметрів переадресації службових записок"),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }